module.exports = __webpack_public_path__ + "static/fonts/yxl-font.4a87408.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/yxl-font.woff?hash=1531290333696
// module id = 1900
// module chunks = 115